import React from "react";
import { MyGroupElement } from "@/features/my-data/components/my-group-element";
import { useAccountGroupsContext, AccountGroups } from "@/features/accounts/account-group/contexts/account-groups-context";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";
import { useTradeJumpContext } from "@/features/trade-jump/contexts/trade-jump-context";


type AccountsListProps = {
  accountGroup: AccountGroups;
  id: string;
};

export const MyGroup = ({ accountGroup, id }: AccountsListProps) => {
  const {
    setTargetAccountGroup,
  } = useAccountGroupsContext();
  const {
    setOpenMyDataModal,
  } = useModalContext();
  const { syncJump } = useTradeJumpContext();

  return (
    <>
      <input type="checkbox" id={`lblGroup-${id}`} className="toggle"/>
      <section className="group">
      <header>
        <h3 className="btn-group">
          {`${accountGroup.accountGroupsName} (${accountGroup.accountsList.length})`}
        </h3>
        <BaseRoundButton
          className="open-modal btn-menu"
          onClick={() => {
            setTargetAccountGroup(accountGroup);
            setOpenMyDataModal("GroupMenu");
          }}
        />
        <label htmlFor={`lblGroup-${id}`} className="lbl_toggle"></label>
      </header>

      {accountGroup.accountsList.map(item => (
        <MyGroupElement
          key={`${item.mlinkAccountId}-${item.mlinkId}`}
          passbookName={item.passbookName}
          passbookType={item.passbookType}
        />
      ))}
      <input
        type="checkbox"
        id="checkStatusShare"
        checked={accountGroup.shared === 1}
        readOnly
      />
      <BaseRoundButton
        buttonText={<strong>共有中</strong>}
        className="open-modal status-share"
        onClick={() => {
          setTargetAccountGroup(accountGroup);
          setOpenMyDataModal("ShareMember");
        }}
        isActive={syncJump !== true}
      />
    </section>
    </>
  );
};